import axios from 'axios';

export const baseURL =
    process.env.REACT_APP_API_BASE_URL ??
    'https://farmgro-api.asterdio.xyz/api';

export const api = axios.create({
    baseURL
});
